import { defineStore } from "pinia";
// 定义一个关于commoninfo的store
const commoninfoStore = defineStore("commoninfo", {
  // defineStore('commoninfo',{})  commoninfo就是这个仓库的名称name
  state: () => ({
    userInfo: localStorage.getItem("userInfo") || {},
    change_path: localStorage.getItem("change_path") || "pc",
    changeToMobileWidth: 832, // 以这个宽度为界限  显示pc版或者mobile版  // 956 200%    1280 150%  1092 %175
    changeToMobileTopMenuWidth: 1080, // 以这个宽度为界限  显示pc版或者mobile版顶部菜单
    pageWidth: "", // 页面宽度（实时监控的）
    num: 1,
    baseinfo: localStorage.getItem("baseinfo") || {},
    menuTop: localStorage.getItem("menuTop") || [],
    menuDown: localStorage.getItem("menuDown") || [],
    menuRoutes: {},
    isAuthenticated: false,
    token: localStorage.getItem("token") || "",
    onlinelist: localStorage.getItem("onlinelist") || [],
    phone: localStorage.getItem("phone") || "",
    UserName: localStorage.getItem("UserName") || "",
    language: "zh-CN", // en
    showSubMenu: false, // 是否显示下拉菜单
    currentSubMenuId: -1, // 当前下拉菜单一级id
    currentSubMenuIndex: -1, // 当前下拉菜单一级index
    currentSubMenuIndex_copy: -1, // 当前下拉菜单一级index  不变的备份
    showMessageCard: true, // 是否展开留言卡片
    showMessageCardFirst: true, // 是否是初始展开留言卡片（初始展开卡片在左下角，其他地方点击打开则展示在中间）

    // mobile------------------------------------
    drawer_open_main: false, // 主菜单是否打开
    drawer_open_lang: false, // 语言页面是否打开
    drawer_open_contact: false, // 联系方式页面是否打开
    firstLevelData: {}, // 商品列表一级数据描述
  }),

  getters: { getNum2: (state) => state.num * 2 },

  // 类似methods
  actions: {
    setUserInfo(info = null) {
      this.userInfo = info || "";
      console.log(info);
    },
    setUserName(name = null) {
      this.UserName = name || "";
    },
    setAuthenticated(flag) {
      this.isAuthenticated = flag;
    },
    setPhone(data) {
      this.phone = data;
    },
    setBaseinfo(data) {
      this.baseinfo = data;
    },
    setmenuTop(data) {
      this.menuTop = data;
    },
    setmenuDown(data) {
      this.menuDown = data;
    },
    setmenChangepath(data) {
      this.change_path = data;
    },
    setPageWidth(data) {
      this.pageWidth = data;
    },
    setmentoken(data) {
      this.token = data;
    },
    setonlineData(data) {
      this.onlinelist = data;
    },
    setLanguage(data) {
      this.language = data;
    },
    setShowSubMenu(data) {
      this.showSubMenu = data;
    },
    setShowMessageCard(data) {
      this.showMessageCardFirst = false;
      this.showMessageCard = data;
    },
    setShowMessageCardFirst(data) {
      this.showMessageCardFirst = data;
    },
    setCurrentSubMenuId(data) {
      this.currentSubMenuId = data;
    },
    setCurrentSubMenuIndex(data) {
      this.currentSubMenuIndex = data;
    },
    setCurrentSubMenuIndexCopy(data) {
      this.currentSubMenuIndex_copy = data;
    },
    setChangeToMobileTopMenuWidth(data) {
      this.changeToMobileTopMenuWidth = data;
    },
    setChangeToMobileWidth(data){
      this.changeToMobileWidth=data
    },
    // mobile ------------------------------
    // 主菜单是否打开
    setDrawerOpenMain(data) {
      this.drawer_open_main = data;
    },
    // 语言页面是否打开
    setDrawerOpenLang(data) {
      this.drawer_open_lang = data;
    },
    // 联系方式页面是否打开
    setDrawerOpenContact(data) {
      this.drawer_open_contact = data;
    },
    setFirstLevelData(data) {
      this.firstLevelData.value = {};
      Object.assign(this.firstLevelData, data);
    },
  },

  persist: {
    storage: localStorage, //   sessionStorage
  },
});

export default commoninfoStore;
